import { render, staticRenderFns } from "./UnderfloorHeatingWrapper.vue?vue&type=template&id=554c505e&"
import script from "./UnderfloorHeatingWrapper.vue?vue&type=script&lang=js&"
export * from "./UnderfloorHeatingWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports